/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeEvent, FocusEvent } from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { TextInput, ITextInputProps } from 'UIPackage/MainModule/components/TextInput';

type Value = ITextInputProps['value'];
type ITextInputFieldProps = ITextInputProps & FieldProps<Value, FieldRenderProps<Value>>;

export const TextInputField = (props: ITextInputFieldProps) => {
  const {
    afterSubmit,
    allowNull,
    beforeSubmit,
    data,
    defaultValue,
    format,
    formatOnBlur,
    initialValue,
    isEqual,
    multiple,
    name,
    parse,
    subscription,
    type,
    validate,
    validateFields,
    value,
    ...componentProps
  } = props;

  return (
    <Field
      afterSubmit={afterSubmit}
      allowNull={allowNull}
      beforeSubmit={beforeSubmit}
      data={data}
      defaultValue={defaultValue}
      format={format}
      formatOnBlur={formatOnBlur}
      initialValue={initialValue}
      isEqual={isEqual}
      multiple={multiple}
      name={name}
      parse={parse}
      subscription={subscription}
      type={type}
      validate={validate}
      validateFields={validateFields}
      value={value}
    >
      {({ input, meta }) => {
        const { onBlur, onChange, onFocus, ...restComponentProps } = componentProps;

        function handleBlur(e: FocusEvent<HTMLInputElement>) {
          input.onBlur(e);
          onBlur?.(e);
        }

        function handleChange(e: ChangeEvent<HTMLInputElement>) {
          input.onChange(e);
          onChange?.(e);
        }

        function handleFocus(e: FocusEvent<HTMLInputElement>) {
          input.onFocus(e);
          onFocus?.(e);
        }

        const error =
          (meta.touched && restComponentProps.error) || (meta.touched && meta.error) ? meta.error : undefined;
        const errorOnSubmit = meta.error && (meta.dirty || meta.submitFailed) && meta.touched && meta.error;

        return (
          <TextInput
            {...restComponentProps}
            {...input}
            error={restComponentProps.validateOnSubmit ? errorOnSubmit : error}
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          />
        );
      }}
    </Field>
  );
};
